/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ResourceAudienceEntry,
  ResourceAudienceEntry$inboundSchema,
} from "./resourceaudienceentry.js";
import {
  ResourceAudienceRolePlugin,
  ResourceAudienceRolePlugin$inboundSchema,
} from "./resourceaudienceroleplugin.js";

export type ResourceAudienceResult = {
  /**
   * Rules deciding access to this resource, widest first.
   */
  entries: Array<ResourceAudienceEntry>;
  /**
   * Live plugins containing this resource and assigned to an exact audience role. Omitted without plugin read and administrator access; not evidence of authorization or installation.
   */
  rolePlugins?: Array<ResourceAudienceRolePlugin> | undefined;
  /**
   * Fingerprint of the rules naming this resource. Send it back when saving so a change made elsewhere is a conflict rather than a silent overwrite.
   */
  version: string;
};

/** @internal */
export const ResourceAudienceResult$inboundSchema: z.ZodMiniType<
  ResourceAudienceResult,
  unknown
> = z.pipe(
  z.object({
    entries: z.array(ResourceAudienceEntry$inboundSchema),
    role_plugins: z.optional(z.array(ResourceAudienceRolePlugin$inboundSchema)),
    version: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "role_plugins": "rolePlugins",
    });
  }),
);

export function resourceAudienceResultFromJSON(
  jsonString: string,
): SafeParseResult<ResourceAudienceResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResourceAudienceResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResourceAudienceResult' from JSON`,
  );
}
